import * as React from 'react';
import type { IconSize } from '@components/atoms/Icon/icon-prop-types';
import { IconSizes } from '@components/atoms/Icon/icon-prop-types';

/**
 * Brand colors of the organization and program tile avatars. They are fixed artwork, like `GCIcon`,
 * so the tiles take no `fill` — recoloring one would break the brand mark.
 */
export const TILE_COLORS = {
    background: '#021644',
    glyph: '#00348A',
    accent: '#00FF98',
    outline: 'white',
} as const;

interface TileIconFrameProps {
    size: IconSize;
    /** Overrides `size` for avatar sizes the icon scale lacks, such as a 40px list avatar. */
    width?: number;
    height?: number;
    testId: string;
    children: React.ReactNode;
}

/** The navy rounded square with a white outline that every tile avatar draws its glyph on. */
export const TileIconFrame = ({ size, width, height, testId, children }: TileIconFrameProps) => (
    <svg
        width={width ?? IconSizes[size]}
        height={height ?? IconSizes[size]}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        data-testid={testId}
    >
        <path
            d="M1 3.4C1 2.07452 2.07452 1 3.4 1H20.6C21.9255 1 23 2.07452 23 3.4V20.6C23 21.9255 21.9255 23 20.6 23H3.4C2.07452 23 1 21.9255 1 20.6V3.4Z"
            fill={TILE_COLORS.background}
        />
        <path
            d="M0 20.6V3.4C2.06176e-07 1.52223 1.52223 0 3.4 0V1C2.07452 1 1 2.07452 1 3.4V20.6L1.00078 20.6619C1.03362 21.9588 2.09522 23 3.4 23H20.6L20.6619 22.9992C21.9382 22.9669 22.9669 21.9382 22.9992 20.6619L23 20.6V3.4C23 2.09522 21.9588 1.03362 20.6619 1.00078L20.6 1V0C22.4778 0 24 1.52223 24 3.4V20.6C24 22.4778 22.4778 24 20.6 24H3.4C1.52223 24 0 22.4778 0 20.6ZM20.6 0V1H3.4V0H20.6Z"
            fill={TILE_COLORS.outline}
        />
        {children}
    </svg>
);
